/**
 * Sum every fee on an otherFees object (seat selection, baggage, booking, service, ATOL, credit, ...)
 */
export function sumOtherFees(otherFees: App.Checkout.OtherFees | undefined): number {
  return Object.values(otherFees ?? {}).reduce<number>((acc, fee) => acc + (fee ?? 0), 0)
}
